import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=b4ca6af0&scoped=true&"
import script from "./Bonuses.vue?vue&type=script&lang=js&"
export * from "./Bonuses.vue?vue&type=script&lang=js&"
import style0 from "./Bonuses.vue?vue&type=style&index=0&id=b4ca6af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ca6af0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDialog,VSkeletonLoader,VTextField})
